import { types } from 'mobx-state-tree';
import { RowModel } from '../rowModel';
import { ApplicationTypesModel } from './applicationTypesModel';
import { TextsConfigurationModel } from './textsConfigurationModel';

const ExternalApplicationSettings = types
  .model('ExternalApplicationSettingsModel', {
    textsConfiguration: types.maybe(TextsConfigurationModel),
    availableApplicationTypes: types.maybe(ApplicationTypesModel),
    mapUrl: types.maybe(types.string),
    typeName: types.maybe(types.string),
    content: '{}'
  })
  .volatile(() => ({
    hasChanges: false
  }))
  .actions(self => ({
    setHasChanges(hasChanges) {
      self.hasChanges = hasChanges;
    },
    update({ mapUrl, ...applicationTypes }) {
      self.availableApplicationTypes = applicationTypes;
      self.mapUrl = mapUrl;
    }
  }));

export const ExternalApplicationSettingsModel = types
  .compose(RowModel, ExternalApplicationSettings)
  .named('ExternalApplicationSettingsStore');
